<template>
  <div v-if="total" class="cart-total">
    <span class="cart-total__title">{{ $t('order_total') }}:</span>
    <span class="cart-total__price">
      {{ $isGlobalStore ? this.total : formatPrice(this.total) }}</span
    >
  </div>
</template>
<script>
import priceable from '~/mixins/priceable'

export default {
  mixins: [priceable],
  props: {
    total: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.cart-total {
  font-size: 15px;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 10px 18px;
  align-items: baseline;

  .cart-total__title {
    font-weight: bold;
  }

  .cart-total__price {
    width: 80px;
    text-align: right;
    font-weight: bold;
  }
}
</style>
